import script from "./YeeBindMiniapp.vue?vue&type=script&lang=ts&setup=true"
export * from "./YeeBindMiniapp.vue?vue&type=script&lang=ts&setup=true"

import "./YeeBindMiniapp.vue?vue&type=style&index=0&id=b83fa9ba&lang=scss"

const __exports__ = script;

export default __exports__